import React from 'react';
import { createRoot } from 'react-dom/client';

import './index.css';
import reportWebVitals from './reportWebVitals';

const importBuildTarget = () => {
  // DefinePlugin in webpack.config.js will substitute
  // process.env.REACT_APP_BUILD_TARGET with it's value at build time.
  // https://webpack.js.org/plugins/define-plugin/

  // TerserPlugin in webpack.config.js will eliminate dead code
  // ...if we make it easy enough (no maps or switches, etc).
  // https://webpack.js.org/plugins/terser-webpack-plugin/

  if (process.env.REACT_APP_BUILD_TARGET === 'webview') {
    return import('./webview/WebviewRoot');
  }
  if (process.env.REACT_APP_BUILD_TARGET === 'votell') {
    return import('./votell/VotellRoot');
  }
  return Promise.reject(
    new Error(
      `No such build target: ${
        process.env.REACT_APP_BUILD_TARGET || 'undefined'
      }`
    )
  );
};

// Import the entry point and render it's default export
const rootElement = document.getElementById('root');
if (rootElement) {
  void importBuildTarget().then(({ default: Root }) => {
    const root = createRoot(rootElement);
    root.render(
      <React.StrictMode>
        <Root />
      </React.StrictMode>
    );
  });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
